import { useState } from 'react';
import { useAppStore } from '../store/useAppStore.js';
import { supabase } from '../lib/supabase.js';
import { AlertIcon, CheckIcon } from '../icons.js';

export function ForgotPasswordView() {
  const setView = useAppStore((s) => s.setView);
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { error: rpErr } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/`,
      });
      if (rpErr) throw new Error(rpErr.message);
      setSent(true);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up">
      <h2 className="h-card mb-2 text-ink-900 dark:text-ink-100">Reset your password</h2>
      <p className="hint mb-6">We'll email you a link to set a new password.</p>

      {sent ? (
        <div className="inline-flex items-start gap-2 px-3 py-2 rounded-lg
                        text-emerald-700 dark:text-emerald-300
                        bg-emerald-50 dark:bg-emerald-950/40
                        border border-emerald-200 dark:border-emerald-900/60
                        text-[0.9rem]">
          <CheckIcon className="shrink-0 mt-0.5" />
          <span>Check your email — a reset link is on its way.</span>
        </div>
      ) : (
        <form onSubmit={onSubmit} autoComplete="on" className="flex flex-col gap-5">
          <label className="flex flex-col gap-2">
            <span className="field-label">Email</span>
            <input className="input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <button type="submit" className="btn-primary w-full justify-center" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}

      {error ? (
        <div className="notice-error mt-5">
          <AlertIcon className="shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      ) : null}

      <div className="mt-6 text-[0.85rem]">
        <button type="button" onClick={() => setView('login')} className="text-ink-600 dark:text-ink-400 hover:underline">
          ← Back to sign in
        </button>
      </div>
    </div>
  );
}
